import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, forkJoin } from 'rxjs';
import { FunctionsService } from '../__common/functions.service';
import { DependencyService } from '../__common/dependency.service';

@Injectable({
  providedIn: 'root'
})
export class BudgetsResolverService implements Resolve<any>  {

  constructor(private dependencyService : DependencyService,private commonFunctions: FunctionsService) { }

  // Resolver that fetches all needed data before route loads
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    let userId = this.commonFunctions.getSelectedClientId();
    return forkJoin({
      productList: this.dependencyService.getTableData('product',100,0,'dashboard'),
      packageList: this.dependencyService.getTableData('package',100,0,'dashboard'),
      planList: this.dependencyService.getXhr('getClientPlans',userId),
      cotizaciones: this.dependencyService.getXhr('cotizaciones',userId)
    });
  }
}
